"use client";

import { Button } from "@leabankab/component-library";

interface ConfirmationButtonProps {
	label: string;
	/**
	 * Imperative submit handler (attached as `onClick`). Omit when the enclosing
	 * `FormContainer` handles submission and `type="submit"` is used instead.
	 */
	onSubmit?: () => void | Promise<void>;
	/** Native button type. Use `submit` to submit the enclosing `<form>`. */
	type?: "button" | "submit";
}

/**
 * The step's primary action. Always enabled: a submit blocked by validation
 * moves focus to the first problem (see `FormContainer`).
 */
export const ConfirmationButton = ({
	label,
	onSubmit,
	type = "button",
}: ConfirmationButtonProps) => (
	<Button type={type} onClick={onSubmit} className="w-full">
		{label}
	</Button>
);
